// Never include response bodies, credentials or account data in this signal.
const listeners = new Set<() => void>();
let generation = 0;

export class StaleSessionError extends Error {
  constructor() { super('This request belongs to a previous console session.'); this.name = 'StaleSessionError'; }
}

export function sessionGeneration() { return generation; }
export function advanceSessionGeneration() { generation += 1; return generation; }
export function isCurrentSessionGeneration(value: number) { return value === generation; }
export function assertCurrentSessionGeneration(value: number) {
  if (!isCurrentSessionGeneration(value)) throw new StaleSessionError();
}

export function onSessionExpired(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function notifySessionExpired(requestGeneration: number = generation) {
  if (!isCurrentSessionGeneration(requestGeneration)) return;
  // Retire all old requests before listeners clear caches or start a new session read.
  advanceSessionGeneration();
  listeners.forEach(listener => listener());
}
